import axios from 'axios';
import store from '../store/index';
import Vue from 'vue';
import { Notify } from 'vant';
import qs from 'qs';
import util from '@/utils/util';
import { blob2string } from '@/utils/blob2string';
import * as Sentry from '@sentry/browser';
import Cookies from 'js-cookie';

Vue.use(Notify);

if (process.env.NODE_ENV !== 'development') {
  // 走代理环境
  axios.defaults.baseURL = process.env.VUE_APP_URL;
}

// 若当前域名为C端域名，则请求C端接口
if (window.location.host === process.env.VUE_APP_TIM_C_HOST) {
  axios.defaults.baseURL =
    process.env.VUE_APP_TIM_C_HTTP + process.env.VUE_APP_TIM_C_HOST;
}

let loadingNum = 0;
const config = {
  method: 'get',
  // baseURL: SERVICE_URL,
  // baseURL: 'http://172.168.201.230:8082/',
  headers: {
    // 'Content-Type': 'application/json;charset=UTF-8'
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Request-Type-AJAX': '1', // token失效会返回统一json，ret状态码为800401
    showLoading: true, // loading
    mobile: 13000000007
  },
  // data: {},
  timeout: 15000,
  withCredentials: true
  // withCredentials: false // 设置 mock 的时候要启用
  // responseType: 'json'
};
export default function $axios(options) {
  let finalOptions = Object.assign({}, options);
  if (!options.showLoading) {
    config.headers.showLoading = options.showLoading;
  }
  let finalConfig = Object.assign({}, config);
  return new Promise((resolve, reject) => {
    if (finalOptions.method !== 'POST') {
      finalOptions.params = finalOptions.params || {};
      finalConfig.paramsSerializer = function () {
        return qs.stringify(finalOptions.params, { arrayFormat: 'repeat' });
      };
    } else {
      finalOptions.data = finalOptions.isPayload
        ? finalOptions.data
        : qs.stringify(finalOptions.data);
    }
    const myAxios = axios.create(finalConfig);

    // request 拦截器
    myAxios.interceptors.request.use(
      (config) => {
        if (!options.isNotice) {
          if (config.headers.showLoading) {
            loadingNum++;
            store.dispatch('refund/setLoading', true);
          }
        }
        if (process.env.NODE_ENV === 'development') {
          config.headers['x-token'] =
            Cookies.get('X-Token') ||
            Cookies.get('x-token') ||
            'MjQ4NTMwZTYtNDQ2OS00NTBmLWE2MTYtOTRjNjExMmNlMGIw';
        } else {
          config.headers['x-token'] =
            Cookies.get('X-Token') || Cookies.get('x-token');
        }
        console.log(
          `--------config.headers['x-token']-------------`,
          config.headers['x-token'],
          config.url
        );
        config.headers['X-Request-Type-AJAX'] = 1;
        config.headers['mobile'] = store.state.refund.userInfo.mobile;
        config.headers['Content-Type'] = finalOptions.isPayload
          ? 'application/json;'
          : 'application/x-www-form-urlencoded';
        // config.headers['Content-Type'] = 'multipart/form-data'
        if (config.url.indexOf('/investorInfoManage/') !== -1) {
          config.headers['Content-Type'] = 'application/json;charset=UTF-8';
        }

        if (
          config.url.indexOf('/backend/api/attach/fileUpload') !== -1 ||
          config.url.indexOf('/api/refund/getIDCardInfo') !== -1
        ) {
          config.headers['Content-Type'] = 'multipart/form-data';
        }
        if (
          config.url.indexOf(
            '/investment/investorInfoManage/pr-investor-info/delInvestor'
          ) !== -1
        ) {
          config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }
        // Sentry 记录请求日志
        Sentry.captureMessage(
          JSON.stringify({
            pos: 'request',
            content: config
          })
        );
        return config;
      },
      // 请求前需求处理 ps.目前直接返回config
      (finalConfig) => finalConfig,
      // 请求错误处理
      (error) => {
        alert(error);
        loadingNum--;
        console.log('request_error:', error);
        // 拦截不到，要在 response 拦截器上拦截
        if (
          error.code === 'ECONNABORTED' &&
          error.message.indexOf('timeout') !== -1
        ) {
          console.log('请求超时，请稍后再试');
        }
        // Sentry 上报接口异常
        Sentry.captureException(error);
        return Promise.reject(error);
      }
    );

    // response 拦截器
    myAxios.interceptors.response.use(
      async (response) => {
        // Sentry 记录响应日志
        Sentry.captureMessage(
          JSON.stringify({
            pos: 'response',
            content: response
          })
        );

        loadingNum--;
        if (loadingNum <= 0) {
          store.dispatch('refund/setLoading', false);
        }
        let data;
        let errMessage = getErrMessage(response);
        // IE9时response.data是undefined，因此需要使用response.request.responseText(Stringify后的字符串)
        if (response.data === undefined) {
          data = response.request.responseText;
        } else {
          data = response.data;
        }
        if (errMessage) {
          console.log(errMessage);
        }
        if (typeof data === 'undefined' || data === null) {
          console.log('出错了');
          return data;
        }
        // 下载时 response.data.type === 'application/octet-stream'
        if (data.type === 'application/octet-stream') {
          return data;
        }
        // 想请求二进制文件，但是接口报错返回application/json
        if (
          response.config.responseType === 'arraybuffer' ||
          response.config.responseType === 'blob'
        ) {
          if (response.headers['content-type'].includes('application/json')) {
            const jsonstr = await blob2string(data);
            console.log(jsonstr);
            try {
              data = JSON.parse(jsonstr);
            } catch (e) {
              console.error(e);
            }
          } else {
            return data;
          }
        }
        if (typeof data.ret === 'undefined') {
          if (data.code !== 0) {
            Notify({
              type: 'danger',
              message: data.msg,
              className: 'common-notify'
            });
            return Promise.reject(data);
          }
          return data;
        } else {
          // 有 code 代表这是一个后端接口 可以进行进一步的判断
          switch (data.ret) {
            case 0:
              // [ 示例 ] ret === 0 代表没有错误
              return data;
            // 重新登录
            case 800401:
              Notify({
                type: 'danger',
                message: data.msg,
                className: 'common-notify'
              });
              if (localStorage.getItem('X-Token')) {
                util.cookies.set('X-Token', '');
                localStorage.setItem('X-Token', '');
                // 若当前域名为C端域名，则不请求jsb
                if (window.location.host !== process.env.VUE_APP_TIM_C_HOST) {
                  window.yyn.invokeJSB('showLogin');
                }
              }
              return Promise.reject(data);
              break;
            default:
              // 不是正确的 code
              // 考核特殊处理
              console.log(data.msg);
              console.log('🚀 ~ output->[ data ] >', data);
              if (data.msg == null || data.msg === '州市编码【area】不能为空') {
                return Promise.reject(data);
              }
              Notify({
                type: 'danger',
                message: data.msg,
                className: 'common-notify'
              });
              break;
          }
        }
        return data;
      },
      (err) => {
        loadingNum--;
        if (loadingNum <= 0) {
          store.dispatch('refund/setLoading', false);
        }
        if (err && err.response) {
          switch (err.response.status) {
            case 400:
              err.message = '请求错误';
              break;
            case 401:
              err.message = '未授权，请登录';
              break;
            case 403:
              err.message = '拒绝访问';
              break;
            case 404:
              err.message = `请求地址出错:`;
              break;
            case 408:
              err.message = '请求超时';
              break;
            case 500:
              err.message = '服务器内部错误';
              break;
            case 501:
              err.message = '服务未实现';
              break;
            case 502:
              err.message = '网关错误';
              break;
            case 503:
              err.message = '服务不可用';
              break;
            case 504:
              err.message = '网关超时';
              break;
            case 505:
              err.message = 'HTTP版本不受支持';
              break;
            default:
          }
        }
        if (
          err.code === 'ECONNABORTED' &&
          err.message.indexOf('timeout') !== -1
        ) {
          console.log('请求超时，请稍后再试');
        } else {
          // 网络不行,接口未走通
          // vm.$router.push({
          //     path: '/refund/errPage',
          // })
        }
        // Sentry 上报接口异常
        Sentry.captureException(err);
        return Promise.reject(err);
      }
    );

    // 请求处理
    myAxios(finalOptions)
      .then((res) => {
        // store.state
        // console.log('---------------')
        // console.log(store);
        store.dispatch('refund/setLoading', false);
        // console.log(store);
        resolve(res);
        return false;
      })
      .catch((error) => {
        loadingNum--;
        if (loadingNum <= 0) {
          store.dispatch('refund/setLoading', false);
        }
        reject(error);
      });
  });
}

function getErrMessage(err) {
  let message;
  switch (err.status) {
    case 400:
      message = '请求错误';
      break;
    case 401:
      message = '未授权，请登录';
      break;
    case 403:
      message = '拒绝访问';
      break;
    case 404:
      message = `请求地址出错: `;
      break;
    case 408:
      message = '请求超时';
      break;
    case 500:
      message = '服务器内部错误';
      break;
    case 501:
      message = '服务未实现';
      break;
    case 502:
      message = '网关错误';
      break;
    case 503:
      message = '服务不可用';
      break;
    case 504:
      message = '网关超时';
      break;
    case 505:
      message = 'HTTP版本不受支持';
      break;
    default:
      message = '';
  }
  return message;
}
